export enum UploadTypesEnum {
  profilePicture = 'profile-picture',
  invoiceLogo = 'invoice-logo',
  expense = 'expense',
  invoice = 'invoice',
  document = 'document',
  emailAttachment = 'email-attachment',
  documentsRepository = 'repository-document',
  conversationAttachment = 'conversation-attachment',
}
